module.exports = __webpack_public_path__ + "static/media/ax.b7cb7e2a.svg";